export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7097.9eb05eb9.jpg";